
<template>


<div>



<html lang="es">
   
<head>
	
</head>
<body>
	<!--======================================== Boton ir arriba ========================================-->
	<i class="btn-up fa fa-arrow-circle-o-up hidden-xs"></i>
	<!--======================================== Navegación ========================================-->
	<header>
		
	</header>
	<!--======================================== contenido de la pagina ========================================-->
	<section class="full-reset">
		<div>
		  <h3 class="text-center titles">Matricula</h3>
		  <p class="text-center lead">
			 	  	
		  </p>
		</div>
		<!--======================================== Info. ========================================-->
		<article>
			<div class="container">
				<div class="row">
					<div class="col-xs-12">
						<h3 class="text-center">
							La matricula con que cuanta actualmente la escuela es de 1200 estudiantes.
							Todos los años ingresa una gran cantidad de alumnos provenientes de distintos puntos del pais y de otros paises. Esto es debido a que sus familias se radican en la localidad en busca de trabajo.
						</h3>
						<br><br>
						<h4 class="titles">Descargar Formularios De Secretaría</h4>
						<br>
						<p class="lead">
							<iframe src="https://drive.google.com/embeddedfolderview?id=1r2IVZVkzq-0uUJANkHU8DTArDFbagxSb#grid" width="800" height="600" frameborder="1"></iframe>
							
						</p>
					</div>
				</div>
			</div>
		</article>
		<div class="divider-general"></div>
		
		
	</section>
	<!--======================================== Pie de pagina ========================================-->
	
</body>

 </html>

 </div>


    
</template>



<script>




export default {
  name: "Secretaria",
  components: {
   
  }
};

</script>


// WEBPACK FOOTER //
// src/components/Secretaria.vue